import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getSearchListData = async () => {
  const options = prepareRequestOptions(
    '/admin/s3/search-list',
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/s3/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/s3/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/s3/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/s3/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const connectS3Bucket = async (id) => {
  const options = prepareRequestOptions(
    `/admin/s3/${id}/connect`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getS3FilesListData = async (id, params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/s3/${id}/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const transcodeS3Files = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/s3/${id}/files/transcode`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const checkFileStatus = async (id) => {
  const options = prepareRequestOptions(
    `/admin/s3/transcoded-files/${id}/status/check`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const cancelTranscodingJob = async (id) => {
  const options = prepareRequestOptions(
    `/admin/s3/transcoded-files/${id}/cancel-job`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const processAgainTranscoding = async (id) => {
  const options = prepareRequestOptions(
    `/admin/s3/transcoded-files/${id}/process-again`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
